import React from 'react';
import { useIntl } from 'react-intl';

import Grid from '@/components/Grid/Grid';
import GridWrap from '@/components/Grid/GridWrap';
import Link from '@/components/Link/Link';
import PageNext from '@/components/Page/PageNext';
import { NextPage } from '@/pages/_app';

const RegisterPage: NextPage = () => {
  const intl = useIntl();
  const registerTabs = [
    {
      id: 'candidate',
      link: '/register/candidate',
      title: intl.formatMessage({ id: 'app.register.for.developer' }),
    },
    {
      id: 'company',
      link: '/register/company',
      title: intl.formatMessage({ id: 'app.register.for.company' }),
    },
  ];
  return (
    <PageNext title={intl.formatMessage({ id: 'app.register' })}>
      <div className="geecko-registerform-container">
        <Grid container fullHeight alignContent="center" alignItems="center" justify="center">
          <Grid item xs={12}>
            <div style={{ maxWidth: 947, padding: 16, margin: '0 auto' }}>
              <GridWrap>
                <Grid container spacing={3} className="geecko-register-tabs">
                  {registerTabs.map((item) => (
                    <Grid item xs={12} sm={6} key={item.id}>
                      <Link to={item.link}>
                        <div className={`geecko-registertab geecko-registertab--${item.id}`}>
                          <div>{intl.formatMessage({ id: 'app.register' })}</div>
                          {item.title}
                        </div>
                      </Link>
                    </Grid>
                  ))}
                </Grid>
              </GridWrap>
            </div>
          </Grid>
        </Grid>
      </div>
    </PageNext>
  );
};

RegisterPage.accessGroups = 'public';

export default RegisterPage;
